const ENVS = {
  PRODUCTION: 'production',
  STAGING: 'staging',
  DEVELOPMENT: 'development',
};

Object.freeze(ENVS);

export default ENVS;
